/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* === Card swatches: show 6 then clickable +N === */
(function () {
  var MAX_VISIBLE = 6;
  var APPLY_ON = { cards: true, pdp: false }; // set pdp:true if you also want +N on product pages

function makeMoreButton(hiddenCount, productHref) {
  var btn = document.createElement('a');
  btn.className = 'ct-card-swatches__more';
  btn.href = productHref || '#';
  btn.textContent = '+' + hiddenCount;
  btn.setAttribute('aria-label', 'View all colors');
  btn.setAttribute('role', 'link');

  // Don’t block navigation, just stop bubbling to the card
  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    // allow default anchor navigation
  });

  // Keyboard: Space should also navigate
  btn.addEventListener('keydown', function (e) {
    if (e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = btn.href;
    }
  });

  return btn;
}

  function processList(listEl, itemSelector) {
    if (!listEl) return;

    // Avoid double-initializing
    if (listEl.dataset.ctSwatchesInit === '1') return;
    listEl.dataset.ctSwatchesInit = '1';

    // Remove any old +N (in case of rerenders)
    listEl.querySelectorAll('.ct-card-swatches__more').forEach(function (m) { m.remove(); });

    var items = listEl.querySelectorAll(itemSelector);
    if (!items.length) return;
    if (items.length <= MAX_VISIBLE) return;

    for (var i = MAX_VISIBLE; i < items.length; i++) {
      items[i].classList.add('is-hidden');
    }

    var hiddenCount = items.length - MAX_VISIBLE;

// Find the product URL on this card
var card = listEl.closest('.product-item');
var link = card && card.querySelector(
  '.product-item__title a, a.product-item__image-wrapper, .product-item__image a, .product-item a'
);
var href = (link && link.href) ? link.href : '#';

listEl.appendChild(makeMoreButton(hiddenCount, href));
  }

  function initCardSwatches(root) {
    if (!APPLY_ON.cards) return;
    var scope = root || document;

    // Warehouse fallback dots on product cards
    scope.querySelectorAll('.product-item .color-swatch-list').forEach(function (list) {
      processList(list, '.color-swatch');
    });

    // Your metaobject/image swatches on product cards
    scope.querySelectorAll('.product-item__swatch-list .swatches, .product-item .ct-card-swatches .swatches').forEach(function (list) {
      processList(list, '.swatch');
    });
  }

  function initPdpSwatches(root) {
    if (!APPLY_ON.pdp) return;
    var scope = root || document;

    // Warehouse fallback dots on PDP
    scope.querySelectorAll('.product__info .color-swatch-list').forEach(function (list) {
      processList(list, '.color-swatch');
    });

    // Your metaobject/image swatches on PDP
    scope.querySelectorAll('.product__info .swatches').forEach(function (list) {
      processList(list, '.swatch');
    });
  }

  function initAll(target) {
    initCardSwatches(target);
    initPdpSwatches(target);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Re-run when Shopify sections load or reorder (theme editor, etc.)
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { initAll(e.target); });

  // Re-run on dynamic inserts (Ajax/infinite scroll/quick views)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (!m.addedNodes) return;
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (
          (node.matches && node.matches('.product-item, .product__info, .color-swatch-list, .swatches')) ||
          (node.querySelector && node.querySelector('.product-item, .product__info, .color-swatch-list, .swatches'))
        ) {
          initAll(node);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

